import CourseActionTypes from './course.types';

const INITIAL_STATE = {
  courses: null,
  error: null,
  isFetching: false,
};

const courseReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CourseActionTypes.FETCH_COURSES_START:
      return {
        ...state,
        isFetching: true,
      };
    case CourseActionTypes.FETCH_COURSES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        courses: action.payload,
      };
    case CourseActionTypes.FETCH_COURSES_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default courseReducer;
